import _ from 'lodash';

export function selectFeatureFlags(state) {
  return _.get(state, 'featureFlags.flags');
}

export function selectFeatureFlagsLoading(state) {
  return _.get(state, 'featureFlags.flagsLoading');
}
